export const TypeValue = {
  all: 'all',
  choice: 'choice',
  case_study: 'case_study',
  text: 'text',
}

export const Types = [
  { value: TypeValue.all, title: 'All' },
  { value: TypeValue.choice, title: 'Multiple Choice' },
  { value: TypeValue.case_study, title: 'Case Study' },
  { value: TypeValue.text, title: 'Standard' },
]

export const QuestionSchemaTabs = {
  answer: 'Indicative Answer',
  marking_scheme: 'Marking Scheme',
  rubric: 'Rubric',
}

export const Levels = [
  {
    level: '1',
    status: 'Fail',
    color: '#B42318',
    bgColor: '#FEF3F2',
  },
  {
    level: '2',
    status: 'Pass',
    color: '#F79009',
    bgColor: '#FFFAEB',
  },
  {
    level: '3',
    status: 'Merit',
    color: '#17B26A',
    bgColor: '#ECFDF3',
  },
  {
    level: '4',
    status: 'Distinction',
    color: '#0057B8',
    bgColor: '#f0f7ff',
  },
]

export const FileErrs = {
  case_study: 'Case study text is empty',
  question_id: 'Question ID is not unique',
  question_text: 'Question text is empty',
  options: 'Options are empty',
  marking_scheme_indicative_content: 'Indicative content is empty',
  marking_scheme_level_1_mark:
    "Marking scheme level 1's mark range is not valid. The correct format is Min-Max",
  marking_scheme_level_2_mark:
    "Marking scheme level 2's mark range is not valid. The correct format is Min-Max",
  marking_scheme_level_3_mark:
    "Marking scheme level 3's mark range is not valid. The correct format is Min-Max",
  marking_scheme_level_4_mark:
    "Marking scheme level 4's mark range is not valid. The correct format is Min-Max",
  mark: 'Total marks available for this question is not valid',
  'time_limited(m)': 'Time limit for this question is not valid',
  question_type: 'Question type should be "text" or "choice"',
  section_type: 'Section type should be A, B, or C',
  year: 'Year is empty',
  semester: 'Semester is empty',
  question_number: 'Question number is empty',
  sub_questions: 'Sub questions is empty',
}
